/**
 * Token de inyección para ContractRepository
 */

import { InjectionToken } from '@angular/core';
import { ContractRepository } from './contract.repository';

export const CONTRACT_REPOSITORY_TOKEN = new InjectionToken<ContractRepository>('ContractRepository');

